function InlineForm(params) {
    if(!params.form.length) {
        return;
    }

    this.setDefaults(params);
    this.addListeners();
}

InlineForm.prototype.setDefaults = function(params) {
    this.target = params.target;

    this.dom = {
        $form: params.form,
        $field: params.form.find(params.field),
        $idField: params.form.find("input[type=hidden]"),
        $results: params.form.find(params.results),
    };

    this.dom.$results.empty();
}

InlineForm.prototype.addListeners = function() {
    this.dom.$form.on('submit', this.handleSubmission.bind(this));
    this.dom.$field.on('change keyup', this.debounce(this.handleSubmission.bind(this), 200));
    this.dom.$results.on('blur', this.dom.$results.empty.bind(this));
}

InlineForm.prototype.handleSubmission = function(e) {
    e.preventDefault();

    var _this = this,
        value = this.dom.$field.val();

    if(value) {
        $.post(this.target, {
            id: this.dom.$idField.val(),
            text: this.dom.$field.val()
        }, function(data) {
                var results = '';

                if(!data.length) {
                    results = "<li><a>" + _this.dom.$results.data('empty-results') + "</a></li>";
                } else {
                    data.forEach(function(el) {
                        results += "<li><a href=\"" + el.PageLink + "\">" + el.Title + "</a></li>";
                    });
                }

                _this.dom.$results.html(results);
        }).fail(function() {
            _this.dom.$results.html("<li><a href='#'>Nothing Found</a></li>");
        });
    } else {
        _this.dom.$results.html("");
    }
}

InlineForm.prototype.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

$('.wp-more-information__tile-inline-form').each(function(i, el) {
    new InlineForm({
        target: "/api/WorkforcePartnerships/GetEmployers",
        form: $(el),
        field: ".wp-more-information__tile-form-field",
        results: ".wp-more-information__tile-form-results",
    });
});